"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _NavItem = _interopRequireDefault(require("./NavItem"));

var _excluded = ["onClickLogout", "user", "app", "history"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      backgroundColor: 'rgba(255,255,255,0.8)',
      color: theme.palette.primary[700]
    },
    createButton: {
      margin: 20
    },
    topToolbar: {
      backgroundColor: 'white',
      paddingLeft: 0,
      paddingRight: 64
    },
    logo: {
      left: 0,
      margin: 0
    }
  };
});

var NavigationDrawer = function NavigationDrawer(_ref) {
  var onClickLogout = _ref.onClickLogout,
      user = _ref.user,
      app = _ref.app,
      history = _ref.history,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveNavigationDrawer, _extends({}, other, {
    logo: /*#__PURE__*/_react["default"].createElement("img", {
      src: "/images/probeton-logo_small.jpg",
      alt: "logo"
    }),
    classes: {
      topToolbar: classes.topToolbar,
      logoWrapper: classes.logo
    },
    onClickLogout: onClickLogout,
    navItemComponent: _NavItem["default"],
    onOpenLink: function onOpenLink(goTo) {
      // console.log(goTo);
      history.push(goTo);
    }
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.ProfileHeader, {
    user: {
      username: user.person.fullName || user.email,
      role: app,
      avatarUrl: user.person.avatar && user.person.avatar.src
    } // avatar={<Avatar src={user.person?.avatar?.src} />}
    ,
    classes: {
      avatar: classes.avatar
    }
  }));
};

NavigationDrawer.propTypes = {
  onClickLogout: _propTypes["default"].func.isRequired,
  onDrawerRequestClose: _propTypes["default"].func.isRequired,
  onDrawerRequestOpen: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  profile: _propTypes["default"].object
};
NavigationDrawer.defaultProps = {
  profile: null
};
var _default = NavigationDrawer;
exports["default"] = _default;